import { render, staticRenderFns } from "./ViewKpis.vue?vue&type=template&id=8d355756&scoped=true&"
import script from "./ViewKpis.vue?vue&type=script&lang=js&"
export * from "./ViewKpis.vue?vue&type=script&lang=js&"
import style0 from "./ViewKpis.vue?vue&type=style&index=0&id=8d355756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d355756",
  null
  
)

export default component.exports